<div class="email-right-aside">
    <div class="card email-body email-list">
        <div class="mail-header-wrapper">
            <div class="mail-header">
                <div class="form-check form-check-inline">
<!--                    <input class="form-check-input checkbox-primary" id="emailCheckboxA" type="checkbox" value="option1">-->
<!--                    <label class="form-check-label" for="emailCheckboxA"></label>-->
                    <ul class="email-tabs nav" role="tablist">
                        @for (item of tabData; track item) {
                            <li class="nav-item">
                                <a class="nav-link" [ngClass]="{'active show' : openTab == item.value}" (click)="tabActive(item.value)">
                                    <app-feather-icons [icons]="item.icon"></app-feather-icons>
                                    <span>{{item.value}}</span>
                                </a>
                            </li>
                        }
                    </ul>
                </div>
            </div>
            <div class="mail-body">
                <div class="mail-search d-flex-align-items-center">
                    <input class="form-control" type="text" placeholder="Buscar..." [formControl]="searchControl"><i class="fa fa-search"></i>
                </div>
                <div class="light-square" (click)="newTask()"><i class="fa fa-plus"></i></div>
            </div>
        </div>
        <div class="tab-content" id="email-pills-tabContent">
            <div class="tab-pane fade show active" id="inbox-pill" role="tabpanel" aria-labelledby="inbox-pill-tab">
                <div class="mail-body-wrapper">
                    <ul id="paginated-list" data-current-page="1" aria-live="polite">

                        @for (item of task; track item;let i = $index) {
                            <li class="inbox-data">
                                <div class="form-check form-check-inline">
                                    <span>{{item.id}}</span>
                                </div>
                                <div class="inbox-user">
                                    <div class="rounded-border">
                                        <div [ngClass]="getBadgeClass(item.status,1)">
                                            <p class="txt-primary">  {{ getInitials(item.assigned_user_name) }}</p>
                                        </div>
                                    </div>
                                    <p>{{item.assigned_user_name}}</p>
                                </div>
                                <div class="inbox-message">
                                    <div class="email-data">
                                        <span>{{item.title}}</span>
                                        <span><span>{{item.description}}</span></span>
                                        <div class="mt-1">
                                            <li class="row p-0">
                                                <div class="col">
                                                    <span class="mr-4"><span>Área: {{ item.area }}</span></span>
                                                </div>
                                                <div class="col-auto">
                                                    <div [ngClass]="getBadgeClass(item.status,2)">{{item.status}}</div>
                                                </div>
                                            </li>
                                        </div>
                                        @if (item.evidence_urls != null) {
                                            <div class="row p-0 evidence">
                                                <div class="col-auto">
                                                    <app-feather-icons [icons]="'image'" class="badge-light-primary ml-3"  (click)="getEvidenceFiles(item)"></app-feather-icons>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="mr-4"><span>Evidencias</span></span>
                                                </div>
                                            </div>
                                        }
                                        <div class="social-details mt-0">
                                            <ul class="social-follow mt-0">
                                                <li class="row">
                                                    <div class="col-xs-12"><h6 class="f-w-600 mb-0">Creado por:</h6></div>
                                                    <div class="col-xs-12"><span class="f-light">{{ item.create_user_name }} - {{ item.created_at | date:'short' }}</span></div>
                                                </li>
                                                <li class="row">
                                                    <div class="col-xs-12"><h6 class="f-w-600 mb-0">Iniciado por:</h6></div>
                                                    <div class="col-xs-12"><span class="f-light">{{ item.started_user_name }} - {{ item.started_at | date:'short' }}</span></div>
                                                </li>
                                                <li class="row">
                                                    <div class="col-xs-12"><h6 class="f-w-600 mb-0">Finalizado por:</h6></div>
                                                    <div class="col-xs-12"><span class="f-light">{{ item.completed_user_name }} - {{ item.completed_at | date:'short' }}</span></div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="email-timing"><span>{{item.due_date | date:'short' }} </span></div>
                                    <div class="email-options">
                                        @if (item.status == 'Abierto') {
                                            <app-feather-icons  [icons]="'activity'" class="text-warning ml-3" (click)="changeStatus('En proceso', item.id)"></app-feather-icons>
                                        }
                                        @if (item.status == 'En proceso') {
                                            <app-feather-icons [icons]="'check-circle'" class="text-success ml-3" (click)="changeStatus('Finalizado', item.id)"></app-feather-icons>
                                        }
                                        @if (item.status != 'Finalizado') {
                                            <i class="fa fa-pencil envelope-1 show" (click)="edit(item)"></i>
                                            <i class="fa fa-trash-o trash-3" (click)="delete(item)"></i>
                                        }
                                    </div>
                                </div>
                            </li>
                        }
                    </ul>
                </div>
                <div class="mail-pagination">
                    <div class="d-flex justify-content-center">
                        <ngb-pagination
                                [collectionSize]="pagination.totalRecords"
                                [(page)]="pagination.currentPage"
                                [pageSize]="pagination.pageSize"
                                (pageChange)="onPageChange($event)">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<br>
<br>
